import { Badge } from '@klear/ui/components/badge'
import { cn } from '@klear/ui/lib/utils'
import {
  PAYMENT_STATUS_CANCELED,
  PAYMENT_STATUS_DRAFT,
  PAYMENT_STATUS_FAILED,
  PAYMENT_STATUS_PROCESSING,
  PAYMENT_STATUS_RETURNED,
  PAYMENT_STATUS_SCHEDULED,
  PAYMENT_STATUS_SETTLED,
  normalizePaymentStatus,
  type PaymentStatus
} from '@klear/payment/constants'
import { paymentStatusLabel } from '@klear/payment/presentation'

const STATUS_COLORS = {
  [PAYMENT_STATUS_DRAFT]: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300',
  [PAYMENT_STATUS_SCHEDULED]: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-950 dark:text-yellow-300',
  [PAYMENT_STATUS_PROCESSING]: 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300',
  [PAYMENT_STATUS_SETTLED]: 'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-300',
  [PAYMENT_STATUS_FAILED]: 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300',
  [PAYMENT_STATUS_RETURNED]: 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300',
  [PAYMENT_STATUS_CANCELED]: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300'
} as const satisfies Record<PaymentStatus, string>

interface PaymentStatusBadgeProps {
  status: string
  className?: string
}

export function PaymentStatusBadge({ status, className }: PaymentStatusBadgeProps) {
  const normalized = normalizePaymentStatus(status)

  return <Badge className={cn(STATUS_COLORS[normalized], className)}>{paymentStatusLabel(status)}</Badge>
}
